import { Trans, useLingui } from '@lingui/react';
import { CarleadCreationButton, CarleadCreationFormStep1, defaultCarleadSplitFlow, PricedCarsCounter, SplitBuiltDates, SplitMainTypes, SplitManufacturers, useSplitFieldsFlowService, useSplitFieldsProps, useStep1CarleadForm } from '@wkda/carlead-creation-components';
import { useTrackLanding } from '@wkda/funnel-components';
import { Paper } from '@wkda/styleguide';
import CarleadProgress from '../../../../../components/carlead/CarleadProgress';
import ReturningCustomerPopup from '../../../../../components/carlead/ReturningCustomerPopup';
import TrustPilot from '../../../../../components/appointment/TrustPilot';
import React from 'react';
import { useMinimumMileageValidation } from '../../../../../hooks/useMinimumMileageValidation';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const CarleadStep1CustomerPopup = ({
  headlineDesktop = 'carleadCreation.form.mainTitle',
  headlineMobile = 'carleadCreation.form.mainTitle.mobile',
  subheadline = false,
  className = '',
  showCounterHeadline = false
}) => {
  const splitFieldsProps = useSplitFieldsProps();
  const mileageProps = useMinimumMileageValidation();
  const consumerForm = useStep1CarleadForm([splitFieldsProps, mileageProps]);
  const machine = useSplitFieldsFlowService(defaultCarleadSplitFlow);
  const {
    i18n
  } = useLingui();
  useTrackLanding();
  return /*#__PURE__*/_jsxs(Paper, {
    className: "carlead-creation-form__container step-1",
    children: [/*#__PURE__*/_jsx(ReturningCustomerPopup, {}), /*#__PURE__*/_jsx("div", {
      className: `box gap full-height ${className}`,
      children: /*#__PURE__*/_jsxs("div", {
        className: "container",
        children: [showCounterHeadline ? /*#__PURE__*/_jsx(PricedCarsCounter, {}) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("h1", {
            className: "carlead-creation-form__title d-none d-md-block",
            dangerouslySetInnerHTML: {
              __html: i18n._(headlineDesktop)
            }
          }), /*#__PURE__*/_jsx("h1", {
            className: "carlead-creation-form__title d-block d-md-none",
            dangerouslySetInnerHTML: {
              __html: i18n._(headlineMobile)
            }
          })]
        }), subheadline && /*#__PURE__*/_jsx("p", {
          className: "carlead-creation-form__subheadline",
          children: i18n._(subheadline)
        }), /*#__PURE__*/_jsxs(CarleadCreationFormStep1, {
          carleadForm: consumerForm,
          machineService: machine,
          children: [/*#__PURE__*/_jsx(SplitManufacturers, {}), /*#__PURE__*/_jsx(SplitMainTypes, {}), /*#__PURE__*/_jsx(SplitBuiltDates, {}), /*#__PURE__*/_jsx(CarleadProgress, {}), /*#__PURE__*/_jsx(CarleadCreationButton, {
            children: /*#__PURE__*/_jsx(Trans, {
              id: "carleadCreation.form.step1.button"
            })
          })]
        }), /*#__PURE__*/_jsxs("section", {
          className: "trust-box",
          children: [/*#__PURE__*/_jsx("div", {
            className: "d-none d-md-block",
            children: /*#__PURE__*/_jsx(TrustPilot, {
              type: "lead",
              screen: "desktop"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "d-block d-md-none",
            children: /*#__PURE__*/_jsx(TrustPilot, {
              type: "lead",
              screen: "mobile"
            })
          })]
        })]
      })
    })]
  });
};
export default CarleadStep1CustomerPopup;